export default __webpack_public_path__ + "static/media/waterFr.50b9b9d9.jpg";